import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import i18n from 'i18next';
import i18nLanguageDetector from 'i18next-browser-languagedetector';
import i18nHttpApi from 'i18next-http-backend';
import React from 'react';
import ReactDOM from 'react-dom';
import { initReactI18next } from 'react-i18next';
import { Provider } from 'react-redux';
import { getAuthorizationScopes } from './authorization/authorization';
import App from './components/app/App';
import MsalAuthProvider from './services/authentication/authProvider';
import {
  LanguageConfig,
  updateMomentLanguage,
} from './services/languageService';
import * as serviceWorker from './serviceWorker';
import { configureStore } from './store/configureStore';
import { setStore } from './store/store';

const initApp = async () => {
  await initI18n();
  const { store, history } = initRedux();
  renderApp(store, history);
};

const initRedux = () => {
  // Get the application-wide store instance, prepopulating with state from the server where available.
  const history = createBrowserHistory();
  const initialState = (window as any).initialReduxState;
  const store = configureStore(history, initialState);
  setStore(store);
  return { store, history };
};

const initI18n = async () => {
  await i18n
    .use(i18nLanguageDetector)
    .use(initReactI18next)
    .use(i18nHttpApi)
    .init(LanguageConfig);
  updateMomentLanguage(i18n.language);
};

const renderApp = (store: any, appHistory: any) => {
  const rootElement = document.getElementById('root');
  ReactDOM.render(
    <MsalAuthProvider>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={{ scopes: getAuthorizationScopes() }}
      >
        <Provider store={store}>
          <ConnectedRouter history={appHistory}>
            <App history={appHistory} />
          </ConnectedRouter>
        </Provider>
      </MsalAuthenticationTemplate>
    </MsalAuthProvider>,
    rootElement
  );

  serviceWorker.unregister();
};

initApp();
